import script from "./PowertrainSectionV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PowertrainSectionV2.vue?vue&type=script&setup=true&lang=js"

import "./PowertrainSectionV2.vue?vue&type=style&index=0&id=321d24a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-321d24a2"]])

export default __exports__